// export const adminServiceUrl = "https://admin.stride-capital.com/api"

export const adminServiceUrl =
    (window.location.hostname.includes('staging') || window.location.hostname.includes('localhost'))
        ? 'https://admin-staging.stride-capital.com/api'
        : 'https://admin.stride-capital.com/api';
